import axiosInstance from "@/api/axiosInstance";

export class CompanyService {
  private readonly basePath: string;

  constructor(basePath = "/admin/companies") {
    this.basePath = basePath;
  }

  public async getAll(): Promise<any> {
    try {
      const response = await axiosInstance.get(`/api/v1${this.basePath}`);
      return response.data;
    } catch (e: unknown) {
      console.log("Companies getAll threw error", e);
    }
  }

  /** Errors propagate: the view classifies them and renders the failure in place. */
  public async get(id: number): Promise<any> {
    const response = await axiosInstance.get(`/api/v1${this.basePath}/${id}`);
    return response.data;
  }
}
